export default class UploadAdapter {

    constructor( loader, from = 'desc' ) {
        this.loader = loader;
        this.from = from;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then((file) => new Promise((resolve, reject) => {
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file, this.from);
            }));
    }

    // Aborts the upload process.
    abort() {
        if ( this.xhr ) {
            this.xhr.abort();
        }
    }

    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const url = this.loader.isZoomable ? '/exhibits' : '/admin/images-desc';
        xhr.open( 'POST', url, true );
        xhr.setRequestHeader('x-csrf-token', token);
        xhr.responseType = 'json';
    }

    _initListeners( resolve, reject, file ) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${ file.name }.`;

        xhr.addEventListener( 'error', () => reject( genericErrorText ) );
        xhr.addEventListener( 'abort', () => reject() );
        xhr.addEventListener( 'load', () => {
            const response = xhr.response;

            if ( !response || response.error ) {
                return reject( response && response.error ? response.error.message : genericErrorText );
            }

            resolve( {
                default: response.url,
                thumbnail: response.thumbnail,
                image_id: response.image_id,
                image_title: response.image_title,
            } );
        } );

        // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
        // properties which are used e.g. to display the upload progress bar in the editor
        // user interface.
        if ( xhr.upload ) {
            xhr.upload.addEventListener( 'progress', evt => {
                if ( evt.lengthComputable ) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            });
        }
    }

    _sendRequest( file, from ) {
        const data = new FormData();

        data.append( 'upload', file );
        data.append( 'from', from );

        this.xhr.send(data);
    }
}
